import {SET_INSTRUMENT_TYPE_DRAGGING} from 'constants/action-types.js';
import {SET_PULLABLE_PART_DRAGGING} from 'constants/action-types.js';
import {SET_SHOW_FORMANT_EFFECT} from 'constants/action-types.js';
import {SET_SHOWING_FORMANTS} from 'constants/action-types.js';
import {CLEAR_DRAG_DROP} from 'constants/action-types.js';
import {SET_SELECTED_FM_ENVELOPE_TYPE} from 'constants/action-types.js';
import {SET_SELECTED_FM_FORMANT} from 'constants/action-types.js';
import {SET_SELECTED_FM_OPERATOR_DETAILS} from 'constants/action-types.js';
import {SET_SHOW_FORMANT_PRESETS} from 'constants/action-types.js';

const instrumentsReducer = (state = {}, action) => {
    let newState;
    switch (action.type) {
    case CLEAR_DRAG_DROP:
        return {
            ... state,
            pullablePartDragging: undefined
        };
    case SET_SHOW_FORMANT_PRESETS:
        return {
            ... state,
            showFormantPresets: action.payload 
        };
    case SET_SELECTED_FM_ENVELOPE_TYPE:
        return {
            ... state,
            selectedFMEnvelopeType: action.payload
        };
    case SET_SELECTED_FM_OPERATOR_DETAILS:
        return {
            ... state,
            selectedFMOperatorDetails: action.payload
        };
    case SET_SELECTED_FM_FORMANT:
        return {
            ... state,
            selectedFMFormant: action.payload
        };
    case SET_PULLABLE_PART_DRAGGING:
        return {
            ... state,
            pullablePartDragging: action.payload
        };
    case SET_INSTRUMENT_TYPE_DRAGGING:
        return {
            ... state,
            instrumentTypeDragging: action.payload,
        };
    case SET_SHOWING_FORMANTS:
        return {
            ... state,
            showingFormants: action.payload
        };
    case SET_SHOW_FORMANT_EFFECT:
        return {
            ... state,
            showFormantEffect: action.payload
        };
    default:
        return state;
    }
};

export default instrumentsReducer;
